<div class="row">
  <div class="col-12">
    <em class="fas fa-light fa-times cerrar" routerLink="/leaderTest"></em>
    <h4 class="titulo-wizard">Compromiso Moral y Ético</h4>
    <hr class="hrLine" />
  </div>
</div>
<div class="text-container">
  <p>
    <strong>Estimado participante,</strong>
  </p>

  <p>
    Antes de comenzar esta prueba, es importante que sepas que su propósito es exclusivamente diagnóstico. Los
    resultados
    no tendrán ninguna consecuencia académica ni afectarán tu desempeño escolar. Su única finalidad es brindarte una
    visión honesta y útil sobre tus pensamientos y comportamientos en distintas situaciones.
  </p>

  <p>
    Te invitamos a responder cada pregunta con total sinceridad, tal como piensas y actúas en la vida real. Tu
    honestidad
    es clave para que el diagnóstico refleje con precisión tu realidad.
  </p>

  <p>
    Ten la seguridad de que todas tus respuestas serán tratadas con confidencialidad y respeto. Tu colaboración y
    compromiso son esenciales para el éxito de este proceso.
  </p>


</div>
<div class="row">
  <div class="col-12 text-center">
    <button class="btn-continuar" (click)="emitNextButtonClick()">Continuar</button>
    <img alt="U360 logo" id="home-logo" src="assets/navbar/logo.png" />
  </div>
</div>